import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=9dea86a2&scoped=true"
import script from "./PageHome.vue?vue&type=script&lang=ts"
export * from "./PageHome.vue?vue&type=script&lang=ts"
import style0 from "./PageHome.vue?vue&type=style&index=0&id=9dea86a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dea86a2",
  null
  
)

export default component.exports